import { Voucher } from 'utils/Voucher';

export const mockVouchers: Voucher[] = [
  {
    code: 'TENPERCENT',
    discountType: 'Percentage',
    discountValue: 10,
    isValid: true,
  },
  {
    code: 'FIFTEENOFF',
    discountType: 'Fixed',
    discountValue: 15,
    isValid: true,
  },
  {
    code: 'HIDDEN_TENPERCENT',
    discountType: 'Percentage',
    discountValue: 10,
    isValid: false,
  },
  {
    code: 'HIDDEN_FIFTEENOFF',
    discountType: 'Fixed',
    discountValue: 15,
    isValid: false,
  },
];
